import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import articleStatuses from "astrid-firestore/src/api/articles/constants/articleStatuses";

import { getItem, setItem } from "../../../../utils/localStorage";
import OpenButton from "../../../ui/components/OpenButton/OpenButton";
import Toast from "../../../ui/components/Toast/Toast";

import hardCodedFeatureFlags from "../../../authorization/constants/hardCodedFeatureFlags";
import { useOrganizationId } from "../../../organizations/state/organizationId";
import Table from "../../../tables/components/Table";

import ArticleDistributeModal from "../../components/ArticleDistributeModal/ArticleDistributeModal";
import useArticlesTableColumns from "../../hooks/useArticlesTableColumns";

export default function ArticlesTablesView({ organization, data, channels }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const organizationId = useOrganizationId();

	const columns = useArticlesTableColumns({ organization, channels });

	return (
		<Table
			data={data}
			columns={columns}
			enableCheckboxes={(article) => article.status === articleStatuses.READY}
			enableColumnSelector
			onChangeVisibleColumns={(visibleColumns) => {
				return setItem(`columns.articles.${organizationId}`, visibleColumns);
			}}
			visibleColumns={getItem(`columns.articles.${organizationId}`)}
			getDropdownMenuOptions={({ work }) => [
				{
					text: t("view", "View"),
					linkTo: `../works/${work?.id}`,
				},
			]}
			onClick={({ work }) => navigate(`../works/${work?.id}`)}
			style={{ zIndex: 0 }}
		>
			{({ selectedRows }) => (
				<Toast open={selectedRows.length > 0 && hardCodedFeatureFlags.distributeMultipleArticles}>
					<OpenButton text={t("deliverAll", "Deliver all")}>
						{({ setOpen }) => (
							<ArticleDistributeModal
								publisher={organization}
								articles={selectedRows}
								onClose={() => setOpen(false)}
							/>
						)}
					</OpenButton>
				</Toast>
			)}
		</Table>
	);
}
